"use client";

import { PropsWithChildren } from "react";
import ErrorBoundaryWithToast, { getErrorDetails } from "./ErrorBoundaryWithToast";
import ErrorContent from "./src/500/ErrorContent";

// Shows the same 500 page as global-error.tsx. ErrorContent logs the Mixpanel
// "500" event itself, so the boundary's own "errorToast" event is turned off.
const RootErrorBoundary = ({
  children
}: PropsWithChildren) => <ErrorBoundaryWithToast location='RootLayout' reportToMixpanel={false} fallback={({
  error,
  eventId
}) => <ErrorContent errorDetail={getErrorDetails(error)} sentry_error_id={eventId} />} data-sentry-element="ErrorBoundaryWithToast" data-sentry-component="RootErrorBoundary" data-sentry-source-file="RootErrorBoundary.tsx">
    {children}
  </ErrorBoundaryWithToast>;
export default RootErrorBoundary;